import React from "react";
import { useParams, Link } from "react-router-dom";
import teamMembers from "./teamMembersDetails.js";

export default function MemberDetails() {
  const { slug } = useParams();

  const member = teamMembers.find((item) => item.slug === slug);

  if (!member) {
    return (
      <section className="member-details not-found">
        <h2>Member not found</h2>
        <Link to="/" className="back-btn">← Back</Link>
      </section>
    );
  }

  return (
    <section className="member-details">
      <div className="member-details-container">

        {/* LEFT: IMAGE */}
        <div className="member-image-box">
          <img
            src={member.img}
            alt={member.name}
            className="member-details-img"
          />
        </div>

        {/* RIGHT: CONTENT */}
        <div className="member-content-box">
          <h1 className="member-name">{member.name}</h1>
          <h4 className="member-title">{member.title}</h4>
          <p className="member-company">{member.company}</p>

          <div className="member-divider"></div>

          <p className="member-details-bio">
            {member.fullBio || member.bio}
          </p>

          <Link to="/" className="back-btn">
            ← Back to Members
          </Link>
        </div>

      </div>
    </section>
  );
}
